/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForCompliance extends models.GovernanceConfigurationBase {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForCompliance");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForCompliance.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForCompliance>): GovernanceConfigurationForCompliance {
        let obj = Object.assign(new GovernanceConfigurationForCompliance(), model);
        GovernanceConfigurationForCompliance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForCompliance>): GovernanceConfigurationForCompliance {
        if (!model) return null;
        return GovernanceConfigurationForCompliance.newInstance(<GovernanceConfigurationForCompliance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForCompliance) {
        if (!obj) return;

        models.GovernanceConfigurationForCompliance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForCompliance): boolean {
        if (models.GovernanceConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForCompliance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
    }

    /**
     * Notification settings for Compliance
     */
    notifications: models.ConfigurationForNotifications;

}
